import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CreatePinModel, LoginModel, LoginResponseModel, ResetPasswordModel, ResetPinModel, SendOTPModel, ValidateOTPModel, ValidatePinModel } from 'model/auth-model';
import { ApiResponse } from 'model/response-model';
import { BaseUrl } from './baseUrl';

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl: BaseUrl }),
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    login: builder.mutation<ApiResponse<LoginResponseModel>, LoginModel>({
      query: (credentials) => ({
        url: `Auth/login/validate-credentials`,
        method: 'POST',
        body: credentials,
      }),
    }),
    enterPin: builder.mutation<ApiResponse<LoginResponseModel>, CreatePinModel>({
      query: (credentials) => ({
        url: `Auth/pin`,
        method: 'POST',
        body: credentials,
      }),
    }),
    validatePin: builder.mutation<ApiResponse<LoginResponseModel>, ValidatePinModel>({
      query: (credentials) => ({
        url: `Auth/login/validate-pin`,
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPinSendOtp: builder.mutation<ApiResponse<LoginResponseModel>, SendOTPModel>({
      query: (credentials) => ({
        url: `Auth/pin/reset/send-otp`,
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPin: builder.mutation<ApiResponse<LoginResponseModel>, ResetPinModel>({
      query: (credentials) => ({
        url: `Auth/pin/reset`,
        method: 'POST',
        body: credentials,
      }),
    }),
    sendOtp: builder.mutation<ApiResponse<LoginResponseModel>, SendOTPModel>({
      query: (credentials) => ({
        url: `Auth/login/send-otp`,
        method: 'POST',
        body: credentials,
      }),
    }),
    validateOtp: builder.mutation<ApiResponse<LoginResponseModel>, ValidateOTPModel>({
      query: (credentials) => ({
        url: `Auth/login/validate-otp`,
        method: 'POST',
        body: credentials,
      }),
    }),
    forgotPassword: builder.mutation<ApiResponse<String>, String>({
      query: (email) => ({
        url: `Auth/password/reset/email/${email}`,
        method: 'POST',
        body: email,
      }),
    }),
    resetPassword: builder.mutation<ApiResponse<String>, ResetPasswordModel>({
      query: (password) => ({
        url: `Auth/password/reset`,
        method: 'POST',
        body: password,
      }),
    }),
  }),
});


// Export the auto-generated hooks
export const { 
  useLoginMutation, 
  useEnterPinMutation, 
  useValidatePinMutation, 
  useResetPinSendOtpMutation, 
  useResetPinMutation,
  useSendOtpMutation,
  useValidateOtpMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation
} = authApi;
